import { toast } from "react-toastify";
import { CLOSE_DEFINITIVE_RECEIVING, CLOSE_RECEVING, CREATE_RECEVING, DELETE_RECEVING_ITEM, UPDATE_RECEVING_ITEM } from "../../ActionType/ActionType";


const initSate={
    isLoading : false,
}


export const ReceivingReducuer=(state=initSate, action)=>{
    switch (action.type) {


        case CREATE_RECEVING.REQUEST:
            return {...state, isLoading : true}
        case CREATE_RECEVING.SUCCESS:
            toast.success("Receiving créé avec succès")
            return {...state, isLoading : false}
        case CREATE_RECEVING.FAILURE:
            toast.error("Echèc de création du receiving")
            return {...state, isLoading : false}


        case CLOSE_RECEVING.REQUEST:
            return {...state, isLoading : true}
        case CLOSE_RECEVING.SUCCESS:
            toast.success("Fermeé avec succès")
            return {...state, isLoading : false}
        case CLOSE_RECEVING.FAILURE:
            toast.error("Echèc de fermeture du receiving")
            return {...state, isLoading : false}


        case UPDATE_RECEVING_ITEM.REQUEST:
            return {...state, isLoading : true}
        case UPDATE_RECEVING_ITEM.SUCCESS:
            toast.success("Produit mise à jour")
            return {...state, isLoading : false}
        case UPDATE_RECEVING_ITEM.FAILURE:
            toast.error("Echèc de mise à jour")
            return {...state, isLoading : false}


        case DELETE_RECEVING_ITEM.REQUEST:
            return {...state, isLoading : true}
        case DELETE_RECEVING_ITEM.SUCCESS:
            toast.warn("Suppresion réussie")
            return {...state, isLoading : false}
        case DELETE_RECEVING_ITEM.FAILURE:
            toast.error("Echèc de suppression")
            return {...state, isLoading : false}


        case CLOSE_DEFINITIVE_RECEIVING.REQUEST:
            return {...state, isLoading : true}
        case CLOSE_DEFINITIVE_RECEIVING.SUCCESS:
            toast.warn("Cloturé avec réussie")
            return {...state, isLoading : false}
        case CLOSE_DEFINITIVE_RECEIVING.FAILURE:
            toast.error("Echèc de cloture")
            return {...state, isLoading : false}
            
        default: return  state
    }
}